module.exports = __webpack_public_path__ + "img/thumb_image7.85854fe9.jpg";